export const DEFAULT_ROUTE = '/pages';

export const routes = [DEFAULT_ROUTE];
